export const BLOCK_BASE_HEIGHT = 200;
export const IMAGE_BASE_WIDTH = 375;
export const BORDER_RADIUS_BASE = 12;
export const DEFAULT_RADIUS_RATIO = 0;
export const PX_PER_REM = 16; // Must match the root font-size
export const HERO_HEIGHT_RATIO_RANGE = {
  MIN: 10,
  MAX: 300,
};
export const IFRAME_HEIGHT_RATIO_RANGE = {
  MIN: 10,
  MAX: 300,
};
export const HEIGHT_UNITS = {
  PIXEL: "pixel",
  PERCENT: "percent",
};

export const ratioToMultiplier = (ratio, min, max, opts = {}) => {
  if (ratio < min || ratio > max) {
    throw "Ratio Out Of Range";
  }

  const percent = Math.round(((ratio - min) / (max - min)) * 100);

  return opts.percent ? percent : percent / 100;
};

export const withRatio = (baseValue, ratio, opts = {}) => {
  const options = { unit: "px", integer: false, ...(opts || {}) };
  const value =
    Math.round((0.01 * baseValue * ratio + Number.EPSILON) * 100) / 100;

  return `${options.integer ? Math.round(value) : value}${
    options.unit ? options.unit : ""
  }`;
};

// TODO: Desktop styles - remove
const defaultTextBlockYRatio = (ratio) =>
  Math.max(ratio > 50 ? ratio - 50 : ratio, 0);

// TODO: Desktop styles - remove
// Rebuilds the px padding a block's legacy space_*_ratio props resolved to at
// render time. Returns null when an explicit styles.padding exists or no ratios
// are set, so callers fall back to it only for un-migrated blocks.
export const legacyPaddingFromRatios = (block) => {
  const padding = block.styles && block.styles.padding;
  if (padding != null && String(padding).trim() !== "") return null;

  const { space_top_ratio, space_bottom_ratio, space_x_ratio } = block;
  if (
    space_top_ratio == null &&
    space_bottom_ratio == null &&
    space_x_ratio == null
  ) {
    return null;
  }

  const isTextBlock = block.type === "text_block";
  const topRatio = isTextBlock
    ? defaultTextBlockYRatio(space_top_ratio ?? 100)
    : space_top_ratio ?? 100;
  const bottomRatio = isTextBlock
    ? defaultTextBlockYRatio(space_bottom_ratio ?? 100)
    : space_bottom_ratio ?? 100;

  const top = withRatio(PX_PER_REM, topRatio, { unit: "px" });
  const x = withRatio(PX_PER_REM, space_x_ratio ?? 100, { unit: "px" });
  const bottom = withRatio(PX_PER_REM, bottomRatio, { unit: "px" });

  return top === x && top === bottom ? top : `${top} ${x} ${bottom} ${x}`;
};
